class PubSub {
	subscriptions: { [key: string]: Function[] };

	constructor() {
		this.subscriptions = {};
	}

	publish(topic: string, ...args: any[]) {
		if (this.subscriptions[topic]) {
			// eslint-disable-next-line no-restricted-syntax
			for (const fn of this.subscriptions[topic]) {
				fn(...args);
			}
		}
	}

	subscribe(topic: string, fn: Function) {
		this.subscriptions[topic] = this.subscriptions[topic] || [];
		this.subscriptions[topic].push(fn);
	}

	unsubscribe(topic: string, fn: Function) {
		if (this.subscriptions[topic]) {
			this.subscriptions[topic].forEach((value, index) => {
				if (value === fn) {
					this.subscriptions[topic].splice(index, 1);
				}
			});
		}
	}
}

const pubsub = new PubSub();

export default pubsub;
